'use client';

function Bar({ className }: { className: string }) {
  return <div className={`animate-pulse rounded-full bg-gray-200 ${className}`} />;
}

export { ServeCardSkeleton } from '@church/nextjs-ui/website';

export function FilterBarSkeleton() {
  return (
    <div className="flex items-center gap-2">
      <Bar className="h-12 w-12 sm:w-52" />
      <Bar className="h-12 flex-1" />
      <Bar className="h-12 w-12 sm:w-28" />
    </div>
  );
}
